// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setup-screen {
  position: relative;
  color: var(--black6);
  max-width: 1140px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.setup-screen-input-wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 1.5rem;
}
.setup-screen-input-wrapper > div {
  width: calc(50% - 0.5rem);
}
.setup-screen form {
  margin-bottom: 0;
}
.setup-screen-logo {
  position: absolute;
  width: 7rem;
  height: 2rem;
  top: -3.5rem;
  left: 1rem;
  transition: all 0.3s ease;
}
.setup-screen-logo.finish {
  left: 50%;
  transform: translateX(-50%);
}
.setup-screen-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 70%;
  min-width: 740px;
  border-radius: 0.5rem;
  background: var(--white);
  margin-top: 3rem;
  margin-bottom: 3rem;
  box-shadow: 0px 1px 3px rgba(7, 14, 35, 0.06), 0px 2px 8px -1px rgba(7, 14, 35, 0.05);
}
.setup-screen-header {
  width: 100%;
  padding-bottom: 1.25rem;
  margin-bottom: 1.25rem;
  border-bottom: 1px solid var(--black1);
}
.setup-screen-header-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: var(--black9);
}
.setup-screen-header-subtitle {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--black5);
  margin-top: 0.5rem;
}
.setup-screen-body {
  padding: 1.25rem;
  width: calc(100% - 1rem);
}
.setup-screen-step {
  margin: 0 auto;
  padding: 0 1rem;
  width: calc(100% + 2rem);
  margin-left: -1rem;
  max-height: 0;
}
.setup-screen-step h4 {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  margin-bottom: 1rem;
}
.setup-screen-step-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.setup-screen-step-buttons button {
  width: calc(50% - 0.75rem);
}
.setup-screen-step.current {
  max-height: 3000px;
}
.setup-screen .slider {
  background: var(--white);
}

.crypto-provider-wrapper {
  background: var(--white);
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  display: block;
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
}
.crypto-provider-wrapper .payment-container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem;
}
@media (max-width: 768px) {
  .crypto-provider-wrapper .payment-container-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem;
  }
  .crypto-provider-wrapper .payment-container-header > div {
    width: 100%;
  }
  .crypto-provider-wrapper .payment-container-header button {
    margin-top: 1rem;
    width: 100%;
  }
}
.crypto-provider-wrapper .payment-container-header > div svg {
  min-width: 2.25rem;
  width: 2.25rem;
  height: 2.25rem;
  margin-right: 0.75rem;
}
.crypto-provider-wrapper .payment-container-header > div svg + div span:first-child {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  display: flex;
  margin-bottom: 0.25rem;
}
.crypto-provider-wrapper .payment-container-header > div svg + div span:last-child {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--black5);
}
.crypto-provider-wrapper .payment-container-header > div svg + div span:last-child.connected-status {
  color: var(--green6);
}
.crypto-provider-wrapper .payment-container-header button {
  min-height: 2.25rem;
  height: 2.25rem;
}

.settings-content-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  margin-bottom: 0.25rem;
  margin-top: 0;
}

.settings-content-subtitle {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--black5);
  margin-bottom: 1.25rem;
  margin-top: 0;
}

.paylixecommerce-label {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: var(--black9);
  margin-bottom: 0.5rem;
}

.paylixecommerce-input {
  width: 100%;
  height: 2.5rem;
  padding: 0.5rem 0.75rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--black9);
  background: var(--white);
  border: 1px solid var(--black2);
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out;
}
.paylixecommerce-input:focus {
  outline: none;
  border-color: var(--purple6);
}
.paylixecommerce-input::placeholder {
  color: var(--black4);
}

.alert.purple {
  background: var(--purple0);
  border: 1px solid var(--purple1);
  border-radius: 0.5rem;
  padding: 1rem;
}
.alert.purple .alert-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.alert.purple .alert-content svg {
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .setup-screen-input-wrapper {
    margin-bottom: 0;
  }
  .setup-screen-input-wrapper div {
    width: 100%;
  }
  .setup-screen .react-mde .mde-header-group {
    display: inline-block !important;
  }
  .setup-screen .react-mde .mde-header-group .mde-header-item {
    display: inline-block !important;
    margin-top: 0.125rem;
  }
  .setup-screen-wrapper {
    width: 100%;
    margin: 1rem auto;
    min-width: calc(100% - 2rem);
  }
  .setup-screen-header-title {
    font-size: 16px;
    line-height: 19px;
  }
  .setup-screen-header-subtitle {
    font-size: 13px;
    line-height: 18px;
  }
  .setup-screen-body {
    padding: 1.25rem 1rem;
  }
  .setup-screen-step-buttons {
    flex-wrap: wrap;
  }
  .setup-screen-step-buttons button {
    width: calc(50% - 0.5rem);
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/setup/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;AACJ;AACI;EACE,yBAAA;AACN;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AAFJ;AAII;EACE,SAAA;EACA,2BAAA;AAFN;AAME;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qFAAA;AAJJ;AAOE;EACE,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,sCAAA;AALJ;AAOI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AALN;AAQI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AANN;AAUE;EACE,gBAAA;EACA,wBAAA;AARJ;AAWE;EACE,cAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;AATJ;AAWI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AATN;AAYI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAVN;AAYM;EACE,0BAAA;AAVR;AAcI;EACE,kBAAA;AAZN;AAgBE;EACE,wBAAA;AAdJ;;AAkBA;EACE,wBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,iFAAA;AAfF;AAiBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAfJ;AAiBI;EANF;IAOI,sBAAA;IACA,uBAAA;IACA,aAAA;EAdJ;EAgBI;IACE,WAAA;EAdN;EAiBI;IACE,gBAAA;IACA,WAAA;EAfN;AACF;AAmBM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAjBR;AAqBY;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;AAnBd;AAqBY;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAnBd;AAqBc;EACE,oBAAA;AAnBhB;AA2BI;EACE,mBAAA;EACA,eAAA;AAzBN;;AA8BA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;AA3BF;;AA8BA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;AA3BF;;AA8BA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,cAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,wBAAA;EACA,+BAAA;EACA,uBAAA;EACA,0CAAA;AA3BF;AA6BE;EACE,aAAA;EACA,4BAAA;AA3BJ;AA8BE;EACE,oBAAA;AA5BJ;;AAiCE;EACE,0BAAA;EACA,gCAAA;EACA,qBAAA;EACA,aAAA;AA9BJ;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AA9BN;AAgCM;EACE,cAAA;AA9BR;;AAoCA;EAII;IACE,gBAAA;EApCJ;EAqCI;IACE,WAAA;EAnCN;EAyCI;IACE,gCAAA;EAvCN;EAyCM;IACE,gCAAA;IACA,oBAAA;EAvCR;EAsDE;IACE,WAAA;IACA,iBAAA;IACA,4BAAA;EApDJ;EAyDI;IACE,eAAA;IACA,iBAAA;EAvDN;EA0DI;IACE,eAAA;IACA,iBAAA;EAxDN;EA4DE;IACE,qBAAA;EA1DJ;EAoEI;IACE,eAAA;EAlEN;EAoEM;IACE,yBAAA;EAlER;AACF","sourcesContent":[".setup-screen {\n  position: relative;\n  color: var(--black6);\n  max-width: 1140px;\n  margin: 0 auto;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &-input-wrapper {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    width: 100%;\n    margin-bottom: 1.5rem;\n\n    & > div {\n      width: calc(50% - .5rem);\n    }\n  }\n\n  form {\n    margin-bottom: 0;\n  }\n\n  &-logo {\n    position: absolute;\n    width: 7rem;\n    height: 2rem;\n    top: -3.5rem;\n    left: 1rem;\n    transition: all .3s ease;\n\n    &.finish {\n      left: 50%;\n      transform: translateX(-50%);\n    }\n  }\n\n  &-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 70%;\n    min-width: 740px;\n    border-radius: .5rem;\n    background: var(--white);\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n    box-shadow: 0px 1px 3px rgba(7, 14, 35, 0.06), 0px 2px 8px -1px rgba(7, 14, 35, 0.05);\n  }\n\n  &-header {\n    width: 100%;\n    padding-bottom: 1.25rem;\n    margin-bottom: 1.25rem;\n    border-bottom: 1px solid var(--black1);\n\n    &-title {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 18px;\n      line-height: 22px;\n      color: var(--black9);\n    }\n\n    &-subtitle {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 20px;\n      color: var(--black5);\n      margin-top: .5rem;\n    }\n  }\n\n  &-body {\n    padding: 1.25rem;\n    width: calc(100% - 1rem);\n  }\n\n  &-step {\n    margin: 0 auto;\n    padding: 0 1rem;\n    width: calc(100% + 2rem);\n    margin-left: -1rem;\n    max-height: 0;\n\n    h4 {\n      font-family: \"Inter\";\n      font-style: normal;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 17px;\n      color: var(--black9);\n      margin-bottom: 1rem;\n    }\n\n    &-buttons {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n\n      button {\n        width: calc(50% - .75rem);\n      }\n    }\n\n    &.current {\n      max-height: 3000px;\n    }\n  }\n\n  .slider {\n    background: var(--white);\n  }\n}\n\n.crypto-provider-wrapper {\n  background: var(--white);\n  border-radius: .5rem;\n  margin-bottom: 1rem;\n  display: block;\n  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n\n  .payment-container-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.25rem;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      align-items: flex-start;\n      padding: 1rem;\n\n      & > div {\n        width: 100%;\n      }\n\n      button {\n        margin-top: 1rem;\n        width: 100%;\n      }\n    }\n\n    & > div {\n      svg {\n        min-width: 2.25rem;\n        width: 2.25rem;\n        height: 2.25rem;\n        margin-right: .75rem;\n\n        & + div {\n          span {\n            &:first-child {\n              font-family: 'Inter';\n              font-style: normal;\n              font-weight: 600;\n              font-size: 14px;\n              line-height: 17px;\n              color: var(--black9);\n              display: flex;\n              margin-bottom: .25rem;\n            }\n            &:last-child {\n              font-family: 'Inter';\n              font-style: normal;\n              font-weight: 400;\n              font-size: 12px;\n              line-height: 15px;\n              color: var(--black5);\n              \n              &.connected-status {\n                color: var(--green6);\n              }\n            }\n          }\n        }\n      }\n    }\n\n    button {\n      min-height: 2.25rem;\n      height: 2.25rem;\n    }\n  }\n}\n\n.settings-content-title {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--black9);\n  margin-bottom: 0.25rem;\n  margin-top: 0;\n}\n\n.settings-content-subtitle {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 15px;\n  color: var(--black5);\n  margin-bottom: 1.25rem;\n  margin-top: 0;\n}\n\n.paylixecommerce-label {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 16px;\n  color: var(--black9);\n  margin-bottom: 0.5rem;\n}\n\n.paylixecommerce-input {\n  width: 100%;\n  height: 2.5rem;\n  padding: 0.5rem 0.75rem;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--black9);\n  background: var(--white);\n  border: 1px solid var(--black2);\n  border-radius: 0.375rem;\n  transition: border-color 0.15s ease-in-out;\n\n  &:focus {\n    outline: none;\n    border-color: var(--purple6);\n  }\n\n  &::placeholder {\n    color: var(--black4);\n  }\n}\n\n.alert {\n  &.purple {\n    background: var(--purple0);\n    border: 1px solid var(--purple1);\n    border-radius: 0.5rem;\n    padding: 1rem;\n\n    .alert-content {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      margin-bottom: 0.5rem;\n\n      svg {\n        flex-shrink: 0;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n\n  .setup-screen {\n\n    &-input-wrapper {\n      margin-bottom: 0;\n      div {\n        width: 100%;\n      }\n    }\n\n\n    .react-mde {\n      .mde-header-group {\n        display: inline-block !important;\n\n        .mde-header-item {\n          display: inline-block !important;\n          margin-top: .125rem;\n        }\n      }\n    }\n\n    form {\n\n    }\n\n    &-logo {\n      &.finish {\n\n      }\n    }\n\n    &-wrapper {\n      width: 100%;\n      margin: 1rem auto;\n      min-width: calc(100% - 2rem);\n    }\n\n    &-header {\n\n      &-title {\n        font-size: 16px;\n        line-height: 19px;\n      }\n\n      &-subtitle {\n        font-size: 13px;\n        line-height: 18px;\n      }\n    }\n\n    &-body {\n      padding: 1.25rem 1rem;\n    }\n\n    &-step {\n\n\n      h4 {\n\n      }\n\n      &-buttons {\n        flex-wrap: wrap;\n\n        button {\n          width: calc(50% - .5rem);\n          //white-space: nowrap;\n        }\n      }\n\n      &.current {\n\n      }\n    }\n\n    .slider {\n\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
